import { TFilterExpressionObject } from '../../components/filters/Filters';
import { TListLogsProps } from './queries';

export const changelogGenerateFilters = (props: TListLogsProps) => {
  const { companyId } = props;

  const filterExpression: string[] = [];
  const filterNames: TFilterExpressionObject[] = [];
  const filterValues: TFilterExpressionObject[] = [];

  if (companyId) {
    filterExpression.push('#companyId = :companyId');
    filterNames.push({ key: '#companyId', value: 'companyId' });
    filterValues.push({ key: ':companyId', value: companyId });
  }

  return {
    FilterExpression: filterExpression.join(' AND '),
    ExpressionAttributeNames: filterNames,
    ExpressionAttributeValues: filterValues
  };
};
